import { Box, Button, Checkbox, FormControlLabel, Typography } from '@mui/material'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { getOwnChildBranches, getNonMovementFilterData, getBranchConfig } from '../../../store/reports/reports_action'
import { connect } from 'react-redux'
import DropDownOA from '../../common/dropDownOA'
import {
  appendToUrl,
  buildCompositeFields,
  focusElemnt,
  getLocalData,
  isEmpty,
  navigation3,
  removeDuplicatesFromArray,
} from '../../common/helper'
import { Item } from '../../common/snippets'
import { SplitButton } from '../../common/SplitButton'
import * as sx from '../../common/stylesInline/report_daily_branch'
import { RefreshSvg } from '../../common/svg/refresh'
import { ReportHeading } from './common/ReportHeading'
import * as id from './reportId'
import * as lb from './reportLables'
import {
  includingCrossing,
  PaymentTypesOptions,
  summaryReport,
  crossingTransactions,
  nmrDays,
  MovementReportView,
  showTransaction,
  urls,
  detailedReport,
  excludingCrossing,
} from '../../common/constants'
import Datepicker from '../../common/datePicker'
import { BranchWiseSummary } from './NonMovementTable/BranchWiseSummary'
import { PaymentTypeWise } from './NonMovementTable/PaymentTypeWise'
import { StatusWiseSummary } from './NonMovementTable/StatusWiseSummary'
import { LRWiseDetailedStatus } from './NonMovementTable/LRWiseDetailedStatus'
import DropDown from '../../common/dropDown'
import DropDownMultiSelect from '../../common/dropDownMultiSelect'
import { GetRequest } from '../../common/api'
import { updateLoader, updateModal } from '../../../store/common/common_action'
import * as url from './oldReportsUrls'
import Alert from '../../common/alert'
import ManageColumns from '../../common/ManageColumnsUI'
import * as mdt from '../../common/modaltypes'
import {
  branchWiseSummary,
  columnSummaryDefs,
  nonMovementHeader,
  paymentWiseSummary,
  statusWiseSummary,
} from './NonMovementTable/NonMovementConstant'
import { companySettingsAtom } from '../../common/jotaiState/commonStateAtoms'
import { useAtom, useSetAtom } from 'jotai'
import { ReportTable } from './NonMovementTable/reportTable'
import { paymentModesWithAll, paytypes, TOPAY_COD_RULE, TOPAY_COD_RULE2 } from '../../common/paymentsMode'
import { alertAtom, globalLoaderAtom, modalAtom } from '../../common/jotaiState/globalStateAtoms'

const NonMovementReport = (props) => {
  const {
    data: { common, reports },
    getNonMovementFilterData,
    getBranchConfig,
    updateLoader,
    updateModal,
  } = props
  const { loginData, roleRights, showModal, modalType } = common
  const [companySettings] = useAtom(companySettingsAtom)
  const setLoader = useSetAtom(globalLoaderAtom)
  const setAlert = useSetAtom(alertAtom)
  const [modal, setModal] = useAtom(modalAtom)
  const { UseToPayAsCOD = 0, UseFormattedLRinReports = 0, DefaultCurrencyID = 0 } = companySettings
  const NonMovementPortrait = companySettings?.IsNonMovementPortrait || 0
  const { branchListConfig } = reports
  const { intCompanyID, intUserID, intBranchID } = loginData
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [finYearsOpt, setFinYearsOpt] = useState([])
  const [selState, setSelState] = useState('')
  const updatedPaymentModes = !UseToPayAsCOD
    ? paymentModesWithAll
    : paymentModesWithAll
        .map((item) => {
          if (item.typeId === paytypes.COD) return null
          const codName = TOPAY_COD_RULE[item.typeId]
          return codName ? { ...item, name: codName } : item
        })
        .filter(Boolean)
  const [selCity, setSelCity] = useState('')
  const [selBranch, setSelBranch] = useState('')
  const [selReportView, setselReportView] = useState(MovementReportView[1])
  const [selReportOpt, setSelReportOpt] = useState(detailedReport[0])

  const [selCrossingTrans, setSelCrosssingTrans] = useState(crossingTransactions[1])
  const [selLRStatus, setSelLRStatus] = useState(excludingCrossing[0])
  const [nmDays, setNmDays] = useState(4)
  const [selTransaction, setSelTransaction] = useState(showTransaction[1])
  const [selPaymentType, setSelPaymentType] = useState(updatedPaymentModes)
  const [isBranchWise, setIsBranchWise] = useState(false)
  const [selfinancialYear, setSelfinancialYear] = useState()
  const [tableData, setTableData] = useState([])
  const [tableData2, setTableData2] = useState([])
  const [showReport, setShowReport] = useState(false)
  const [resetFlag, setResetFlag] = useState(false)
  const [filterData, setFilterData] = useState({
    FromDate: '',
    ToDate: '',
    reportOption: '',
    stateName: '',
    cityName: '',
    BranchName: '',
    transaction: '',
    payment: '',
    crossingTrans: '',
    ReportTypeId: '',
    ReportTypeName: '',
    reportOptionId: '',
    financialYear: '',
    paymentTypeId: '',
    paymentTypeName: '',
    crossingTransactions: '',
    crossingTransactionsID: '',
    Status: '',
    IncludeDate: false,
    dataType: 'entry',
  })
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: '',
  })
  const RoleRights = roleRights?.Table1?.[0] || {}
  const { AllowExportExcel = 0 } = RoleRights
  const disableExcel = !AllowExportExcel
  const [isPdfLoading, setIsPdfLoading] = useState(false)
  const [manageColumn, setManageColumn] = useState([])
  const [nonMoveFilterData, setNonMoveFilterData] = useState([])
  const reportName = 'Non - Movement'
  const statusWiseSummaryDefs = statusWiseSummary.flatMap((item) => {
    if (!Array.isArray(item.children)) {
      return {
        ...item,
        align: 'left',
      }
    }
    return item.children.map((child) => ({
      ...child,
      align: 'right',
    }))
  })
  const branchWiseSummaryDefs = branchWiseSummary.map((item) => ({
    ...item,
    align: item.align ? item.align : item?.xlCol?.dataType === 'quantity' ? 'right' : undefined,
  }))

  const paymentWiseSummaryDefs = paymentWiseSummary
    .map((item) => {
      const res = {
        ...item,
        align: item.align ? item.align : item?.xlCol?.dataType === 'quantity' ? 'right' : undefined,
      }
      if (DefaultCurrencyID === 2) {
        if (item.field === 'TotalValuation') {
          res.headerName = 'Insurance\nChrg.'
          res.exportHead = 'Insurance\nChrg.'
        }
        if (item.field === 'ServiceTaxAmount') {
          return false
        }
      }
      return res
    })
    .filter(Boolean)

  const resolveHeaders = (viewId, optId) => {
    if (viewId === 1) {
      return manageColumn.filter((obj) => obj.isSelected)
    }
    if (optId === 1) return paymentWiseSummaryDefs
    if (optId === 2) return branchWiseSummaryDefs
    if (optId === 3) return statusWiseSummaryDefs
    return []
  }
  useEffect(() => {
    const updateColumnDetails = async () => {
      let commonHeader = ''
      let localBrnhTransfCol = await getLocalData('LRWiseDetailsStatusReport2')
      if (localBrnhTransfCol) {
        commonHeader = localBrnhTransfCol
      } else {
        commonHeader = nonMovementHeader
      }
      if (UseFormattedLRinReports !== 3) {
        commonHeader = commonHeader.filter((item) => item.field !== 'FormattedLRNO')
      }
      if (NonMovementPortrait === 1) {
        commonHeader = commonHeader.filter((item) => item.isMandatory)
      }
      if (DefaultCurrencyID === 2) {
        commonHeader = commonHeader
          .filter((col) => col.field !== 'ServiceTaxAmount')
          .map((col) => {
            if (col.field === 'Valuation') {
              return { ...col, header: 'Insu.\nChrg.', exportHead: 'Insu.\nChrg.' }
            }
            return col
          })
      }
      setManageColumn(commonHeader)
    }
    updateColumnDetails()
  }, [UseFormattedLRinReports, NonMovementPortrait])
  const handleClick1 = () => {
    if (selReportOpt.id === 3) {
      setShowAlert({ show: true, message: 'Status wise summary not available in Old Format' })
    } else if (selState === '' || selState === ' ') {
      setShowAlert({ show: true, message: 'Please select State' })
    } else if (selCity === '' || selCity === ' ') {
      setShowAlert({ show: true, message: 'Please select City' })
    } else if (selBranch === '' || selBranch === ' ') {
      setShowAlert({ show: true, message: 'Please select Branch' })
    } else if (selPaymentType.length == 0) {
      setShowAlert({ show: true, message: 'Please select Payment Type' })
    } else {
      let baseUrl = url.nonMovementReport
      const urlData = url.nonMovementReportParams
      urlData.chk = loginData.BusCrsCheckSum
      urlData.FromDate = fromDate.format('YYYY-MM-DD')
      urlData.ToDate = toDate.format('YYYY-MM-DD')
      urlData.intCompanyId = intCompanyID
      urlData.intBranchId = selBranch.CurrentBranchID
      urlData.intUserID = intUserID
      urlData.intTimeNotMovedSince = nmDays
      urlData.AllowViewAllReport = roleRights?.Table1?.[0]?.AllowViewAllBranchReport
      urlData.IncludeDate = isBranchWise ? 1 : 0
      urlData.StatusCode = selLRStatus.id
      urlData.Status = selLRStatus.name
      urlData.SelectBranchName = selBranch?.CurrentBranch || ''
      urlData.intIsDays = 1
      urlData.intDaysOrHours = nmDays
      urlData.IsSummary = selReportView.id === 1 ? 0 : 1
      urlData.IsBranchSummary = selReportOpt.id === 2 && selReportView.id === 0 ? 1 : 0
      urlData.FinYrID = isBranchWise ? 0 : selfinancialYear.id
      urlData.IsTranDtWise = selTransaction.id
      urlData.IsOnlyExpressParcel = 2
      urlData.IsPaymentWise = selPaymentType.length == updatedPaymentModes.length ? 0 : 1
      urlData.strPayTypeID =
        selPaymentType.length != updatedPaymentModes.length
          ? selPaymentType
              .reduce((data, obj) => {
                if (obj.typeId !== 0) {
                  data.push(obj.typeId)
                }
                return data
              }, [])
              .join(',')
          : ''
      urlData.intAllowExportToExcel = 1
      urlData.isV2 = 4
      baseUrl = appendToUrl(baseUrl, urlData)
      window.open(baseUrl, '_blank')
    }
  }
  useEffect(() => {
    if (!isEmpty(loginData)) {
      const body = {
        intUserID: loginData.intUserID,
        intCompanyID: loginData.intCompanyID,
        intBranchID: loginData.intBranchID,
        strBranchName: '',
        strBranchCode: '',
        intStateID: 0,
        intCityID: 0,
        intIsActive: 1,
      }
      getBranchConfig(body)
    }
  }, [loginData])
  const handleFilterData = () => {
    if (moment(toDate).endOf('day').valueOf() - moment(fromDate).startOf('day').valueOf() > 31 * 24 * 60 * 60 * 1000 && isBranchWise) {
      setShowAlert({ show: true, message: 'This report cannot be taken for more than 31 days' })
    } else {
      const body = {
        CompanyID: loginData.intCompanyID,
        UserID: loginData.intUserID,
        intFinYr: selfinancialYear.id,
        FromDate: fromDate.format('YYYY-MM-DD'),
        ToDate: toDate.format('YYYY-MM-DD'),
        IncludeDate: isBranchWise ? 1 : 0,
        IsTranDtWise: selTransaction.id,
      }
      getNonMovementFilterData(body).then((val) => {
        setNonMoveFilterData([])
        if (val.status == 'Success') {
          if (val.Data.Table.length > 0) {
            val.Data.Table.forEach((obj) => {
              if (
                obj.CurrentBranchID === branchListConfig.BranchID &&
                obj.CurrentStateID == branchListConfig.StateID &&
                obj.CurrentCityID === branchListConfig.CityID
              ) {
                setSelBranch(obj)
                setSelCity(obj)
                setSelState(obj)
              }
            })
            setNonMoveFilterData(val.Data.Table)
          }
        }
      })
    }
  }
  const handleStateChange = (val) => {
    setSelState(val)
    setSelCity({ CurrentCity: 'All City', CurrentCityID: 0 })
    setSelBranch({ CurrentBranch: 'All Branch', CurrentBranchID: 0 })
  }
  const handleCityChange = (val) => {
    setSelCity(val)
    setSelBranch({ CurrentBranch: 'All Branch', CurrentBranchID: 0 })
  }
  const generateNonMovementReport = async () => {
    setTableData([])
    setIsPdfLoading(false)
    setShowReport(false)
    if (selState === '' || selState === ' ') {
      setShowAlert({ show: true, message: 'Please select State' })
    } else if (selCity === '' || selCity === ' ') {
      setShowAlert({ show: true, message: 'Please select City' })
    } else if (selBranch === '' || selBranch === ' ') {
      setShowAlert({ show: true, message: 'Please select Branch' })
    } else if (selPaymentType.length == 0) {
      setShowAlert({ show: true, message: 'Please select Payment Type' })
    } else {
      const isAllSelected = selPaymentType.length === updatedPaymentModes.length
      setFilterData({
        ...filterData,
        paymentTypeName: isAllSelected ? 'All Payment' : selPaymentType.map((item) => item.name).join(','),
        ReportTypeId: selReportView.id,
        ReportTypeName: selReportView.name,
        reportOptionId: selReportOpt.id,
        reportOption: selReportOpt.name,
        stateName: selState?.CurrentStateName,
        BranchName: selBranch?.CurrentBranch,
        cityName: selCity?.CurrentCity,
        FromDate: fromDate.format('DD-MMM-YY'),
        ToDate: toDate.format('DD-MMM-YY'),
        IncludeDate: isBranchWise,
        crossingTransactions: crossingTransactions[0].name,
        crossingTransactionsID: crossingTransactions[0].id,
        Status: selLRStatus.name,
        financialYear: isBranchWise ? '-' : selfinancialYear?.name,
      })
      const strPayTypeID = isAllSelected ? '' : selPaymentType.map((item) => item.typeId).join(',')
      const body = {
        intCompanyID: loginData.intCompanyID,
        intUserID: loginData.intUserID,
        intBranchID: selBranch.CurrentBranchID,
        intTimeNotMovedSince: nmDays,
        AllowViewAllReport: roleRights?.Table1?.[0]?.AllowViewAllBranchReport, // TBD
        FromDate: fromDate.format('YYYY-MM-DD'),
        ToDate: toDate.format('YYYY-MM-DD'),
        IncludeDate: isBranchWise ? 1 : 0,
        StatusCode: selLRStatus.id === 'BR' ? 'B' : selLRStatus.id,
        intIsDays: 1,
        CityID: selCity.CurrentCityID,
        StateID: selState.CurrentStateID,
        intFinYr: isBranchWise ? 0 : selfinancialYear.id,
        IsTranDtWise: selTransaction.id,
        IsOnlyExpressParcel: 2,
        IsPaymentWise: isAllSelected ? 0 : 1,
        strPayTypeID,
      }
      if (selPaymentType.length == updatedPaymentModes.length) {
        delete body.strPayTypeID
      }
      const resp = await getNonMovementData(body)
      if (resp.length > 0) {
        setTableData(resp)
        setShowReport(true)
      }
      if (selLRStatus.id === 'BR') {
        body.StatusCode = 'R'
        const resp = await getNonMovementData(body)
        if (resp.length > 0) {
          setTableData2(resp)
        }
      } else {
        setTableData2([])
      }
    }
  }

  const getNonMovementData = async (body) => {
    setLoader(true)
    try {
      const res = await GetRequest(urls.getCargoNonMovedDetails, body)
      if (res?.status !== 'Success') {
        throw new Error(res?.ErrMessage || 'Request Failed')
      }
      const { Table = [], Table1 = [] } = res?.Data || {}
      if (!Array.isArray(Table) || !Array.isArray(Table1)) {
        throw new Error('Invalid Response Structure')
      }
      const isPrimaryView = !!selReportView?.id || selReportOpt?.id === 2 || selReportOpt?.id === 3
      const sourceList = isPrimaryView ? Table : Table1
      if (sourceList.length === 0) {
        return []
      }
      const sourceList2 = sourceList
        .map((item, index) => {
          const bookingMoment = item.BookingDateTime ? moment(item.BookingDateTime) : null
          const bookingDate = bookingMoment ? bookingMoment.format('DD-MMM-YYYY') : ''
          const bookingTime = bookingMoment ? bookingMoment.format('hh:mm A') : ''
          return {
            ...item,
            srNo: index + 1,
            BookingDate: bookingDate,
            BookingTime: bookingTime,
          }
        })
        .map((item) => ({ ...item, ...buildCompositeFields(item, manageColumn) }))
      const paymentRule = isPrimaryView ? TOPAY_COD_RULE : TOPAY_COD_RULE2
      const finalData =
        UseToPayAsCOD !== 1
          ? sourceList2
          : sourceList2.map((item) => ({
              ...item,
              PaymentType: paymentRule[item.PaymentTypeID + ''] ?? item.PaymentType,
            }))

      return finalData
    } catch (err) {
      setAlert({ show: true, msg: err.message, nextId: '' })
      return []
    } finally {
      setLoader(false)
    }
  }

  // Generate Financial Years
  function generateFinancialYears(count) {
    const now = new Date()
    const year = now.getFullYear()
    const month = now.getMonth()
    const currentYear = month >= 3 ? year : year - 1
    const financialYears = []
    const increment = month >= 3 ? 1 : 2
    for (let i = 0; i < count; i++) {
      const startYear = currentYear - i
      const endYear = startYear + 1
      const financialYear = `${startYear}-${String(endYear).slice(-2)}`
      financialYears.push({ id: i + increment, name: financialYear })
    }
    return financialYears
  }
  useEffect(() => {
    let finYears = generateFinancialYears(3)
    setSelfinancialYear(finYears[0])
    setFinYearsOpt(finYears)
  }, [])
  let cityOption = removeDuplicatesFromArray(nonMoveFilterData, 'CurrentCityID').filter(
    (obj) => obj.CurrentStateID == selState?.CurrentStateID || selState?.CurrentStateID == 0
  )
  let stateOption = removeDuplicatesFromArray(nonMoveFilterData, 'CurrentStateID')
  let branchOption = removeDuplicatesFromArray(nonMoveFilterData, 'CurrentBranchID').filter((obj) =>
    selCity?.CurrentCityID !== 0
      ? obj.CurrentCityID == selCity?.CurrentCityID
      : selState?.CurrentStateID == 0
      ? true
      : obj.CurrentStateID === selState?.CurrentStateID
  )
  //handle Close Alert
  const handleCloseAlert = () => {
    setShowAlert({ show: false, message: '' })
  }
  const reset = () => {
    setResetFlag(!resetFlag)
    setIsBranchWise(false)
    setFromDate(moment(new Date()))
    setToDate(moment(new Date()))
    setNmDays(4)
    setSelCity('')
    setSelBranch('')
    setSelState('')
    setselReportView(MovementReportView[1])
    setSelReportOpt(detailedReport[0])
    setSelCrosssingTrans(crossingTransactions[1])
    setSelLRStatus(excludingCrossing[0])
    setSelTransaction(showTransaction[1])
    setNonMoveFilterData([])
  }
  useEffect(() => {
    focusElemnt(id.financialYear)
  }, [])
  const onSaveColumns = (item) => {
    setManageColumn(item)
    localStorage.setItem('LRWiseDetailsStatusReport2', JSON.stringify(item))
  }
  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        <ReportHeading reportName={reportName} />
        <Box sx={sx.reportFlex}>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.selectCompnay}
              label={lb.select_company}
              defaultvalue={loginData.strCompanyName}
              disabled={true}
              minWidth="300px"
            />
          </Item>
          <Item sx={sx.itemsx} className="disabled-wrapper">
            <Button variant="contained" disabled={true} style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary">
              GO
            </Button>
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.financialYear}
              label={lb.financialYear}
              disabled={isBranchWise}
              data={finYearsOpt}
              defaultvalue={selfinancialYear?.name}
              onSelect={setSelfinancialYear}
              idKey={`id`}
              dataKey={`name`}
              nextId={id.showTransaction}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.showTransaction}
              label={lb.showTransaction}
              data={showTransaction}
              defaultvalue={selTransaction?.name || selTransaction}
              idKey={`id`}
              dataKey={`name`}
              isObjArr={true}
              onSelect={setSelTransaction}
              disabled={isBranchWise}
              searchPlaceholder={`Search Transaction`}
              prevId={id.financialYear}
              nextId={id.branchWiseCheck}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <FormControlLabel
              value="end"
              checked={isBranchWise}
              onChange={() => {
                setIsBranchWise(!isBranchWise)
                if (!isBranchWise) {
                  focusElemnt(id.fromDate)
                }
              }}
              onKeyDown={(e) => {
                navigation3(e, isBranchWise ? id.fromDate : 'filterGo', id.showTransaction, () => {})
              }}
              control={<Checkbox id={id.branchWiseCheck} />}
              label={
                <Typography variant="h6" sx={{ fontWeight: '600', lineHeight: '18px' }}>
                  Booking
                  <br />
                  Date Wise
                </Typography>
              }
              labelPlacement="end"
            />
          </Item>
          <Item sx={sx.itemsxGrow} className="input--container bookingDatePicker">
            <Datepicker
              label={lb.fromBookingDate}
              width="100%"
              name={'from_Booking_Date'}
              id={id.fromDate}
              value={fromDate}
              statusChecked={!isBranchWise}
              dateChange={(date) => {
                setFromDate(date)
                focusElemnt(id.toDate)
              }}
            />
          </Item>
          <Item sx={sx.itemsxGrow} className="input--container bookingDatePicker">
            <Datepicker
              label={lb.toBookingDate}
              width="100%"
              name={'to_Booking_Date'}
              id={id.toDate}
              value={toDate}
              statusChecked={!isBranchWise}
              dateChange={(date) => {
                setToDate(date)
                focusElemnt('filterGo')
              }}
            />
          </Item>
          <Item sx={sx.itemsx} className="disabled-wrapper">
            <Button
              id="filterGo"
              variant="contained"
              style={{ ...sx.fullHeight, ...sx.novp }}
              className="btn btn-primary"
              onKeyDown={(e) => {
                navigation3(e, id.stateId, isBranchWise ? id.toDate : id.branchWiseCheck, () => {
                  handleFilterData()
                })
              }}
              onClick={handleFilterData}
            >
              GO
            </Button>
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.stateId}
              label={lb.selectState}
              defaultvalue={selState?.CurrentStateName || selState}
              value={selState?.CurrentStateName || selState}
              data={stateOption.length > 0 ? [{ CurrentStateName: 'All State', CurrentStateID: 0 }, ...stateOption] : stateOption}
              dataKey={`CurrentStateName`}
              idKey={`CurrentStateID`}
              onSelect={handleStateChange}
              isObjArr={true}
              searchPlaceholder={`Search State`}
              disabled={
                !(
                  roleRights?.Table1?.[0]?.AllowViewAllBranchReport ||
                  loginData?.IsBranchAdmin ||
                  loginData?.IsMTPLAdmin ||
                  loginData?.IsAdmin
                )
              }
              // disabled={!(roleRights?.Table1?.[0]?.AllowViewAllBranchReport || roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport || loginData?.IsBranchAdmin || loginData?.IsMTPLAdmin || loginData?.IsAdmin)}
              resetFlag={resetFlag}
              prevId={'filterGo'}
              nextId={id.cityId}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.cityId}
              label={lb.selectCity}
              isObjArr={true}
              onSelect={handleCityChange}
              defaultvalue={selCity?.CurrentCity || selCity}
              value={selCity?.CurrentCity || selCity}
              data={nonMoveFilterData.length > 0 ? [{ CurrentCity: 'All City', CurrentCityID: 0 }, ...cityOption] : cityOption}
              dataKey={`CurrentCity`}
              idKey={`CurrentCityID`}
              searchPlaceholder={`Search City`}
              disabled={
                !(
                  roleRights?.Table1?.[0]?.AllowViewAllBranchReport ||
                  loginData?.IsBranchAdmin ||
                  loginData?.IsMTPLAdmin ||
                  loginData?.IsAdmin
                )
              }
              resetFlag={resetFlag}
              prevId={id.stateId}
              nextId={id.selectBranch}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.selectBranch}
              label={lb.selectBranch}
              defaultvalue={selBranch?.CurrentBranch || selBranch}
              value={selBranch?.CurrentBranch || selBranch}
              isObjArr={true}
              onSelect={setSelBranch}
              data={branchOption.length > 0 ? [{ CurrentBranch: 'All Branch', CurrentBranchID: 0 }, ...branchOption] : branchOption}
              dataKey={`CurrentBranch`}
              idKey={`CurrentBranchID`}
              // disabled={!(roleRights?.Table1?.[0]?.AllowViewAllBranchReport || roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport || loginData?.IsBranchAdmin || loginData?.IsMTPLAdmin || loginData?.IsAdmin)}
              disabled={
                !(
                  roleRights?.Table1?.[0]?.AllowViewAllBranchReport ||
                  loginData?.IsBranchAdmin ||
                  loginData?.IsMTPLAdmin ||
                  loginData?.IsAdmin
                ) && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 0
              }
              searchPlaceholder={`Search Branch`}
              resetFlag={resetFlag}
              prevId={id.cityId}
              nextId={id.SelectDays}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownMultiSelect
              label={lb.paymentType}
              id={id.paymentType}
              // data={PaymentTypesOptions}
              data={updatedPaymentModes}
              searchPlaceholder={`Search By Payment`}
              HasAllSelect={true}
              dataKey={`name`}
              defaultvalue={updatedPaymentModes}
              idKey={`typeId`}
              onSelect={(val) => {
                setSelPaymentType(val)
              }}
              prevId={id.selectBranch}
              nextId={id.SelectDays}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <Typography variant="h6" sx={{ fontWeight: '600', lineHeight: '18px' }}>
              Not Moved
              <br />
              Since Days
            </Typography>
          </Item>
          <Item sx={sx.itemsx}>
            <DropDown
              id={id.SelectDays}
              label={lb.SelectDays}
              data={nmrDays}
              onSelect={(val) => {
                setShowReport(false)
                setNmDays(val)
              }}
              defaultvalue={nmDays || '0'}
              value={nmDays || '0'}
              searchPlaceholder={`Search Days`}
              width="110px"
              prevId={id.selectBranch}
              nextId={id.reportView}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.reportView}
              label={lb.reportView}
              data={MovementReportView}
              defaultvalue={selReportView?.name || selReportView}
              idKey={`id`}
              dataKey={`name`}
              onSelect={(val) => {
                setShowReport(false)
                setselReportView(val)
                if (val.id) {
                  setSelReportOpt(detailedReport[0])
                } else {
                  setSelReportOpt(summaryReport[0])
                }
              }}
              isObjArr={true}
              searchPlaceholder={`Search Report`}
              prevId={id.SelectDays}
              nextId={id.ReportOptions}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.ReportOptions}
              label={lb.ReportOptions}
              defaultvalue={selReportOpt?.name || selReportOpt}
              data={selReportView.id ? detailedReport : summaryReport}
              onSelect={(val) => {
                setShowReport(false)
                setSelReportOpt(val)
                if (val.id === 3 && selReportView.id === 0) {
                  setSelCrosssingTrans(crossingTransactions[0])
                }
              }}
              isObjArr={true}
              idKey={`id`}
              dataKey={`name`}
              searchPlaceholder={`Search Report`}
              prevId={id.reportView}
              nextId={id.crossingTransactions}
            />
          </Item>

          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.crossingTransactions}
              label={lb.crossingTransactions}
              defaultvalue={selCrossingTrans?.name || selCrossingTrans}
              data={crossingTransactions}
              onSelect={(val) => {
                setShowReport(false)
                setSelCrosssingTrans(val)
                if (val.id) {
                  setSelLRStatus(includingCrossing[0])
                } else {
                  setSelLRStatus(excludingCrossing[0])
                }
              }}
              idKey={`id`}
              dataKey={`name`}
              isObjArr={true}
              width="250px"
              searchPlaceholder={`Search Crossig Transaction`}
              prevId={id.ReportOptions}
              nextId={id.status}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.status}
              label={lb.LRStatus}
              defaultvalue={selLRStatus?.name || selLRStatus}
              data={selCrossingTrans.id == 1 ? includingCrossing : excludingCrossing}
              onSelect={(val) => {
                setShowReport(false)
                setSelLRStatus(val)
              }}
              idKey={`id`}
              dataKey={`name`}
              isObjArr={true}
              width="330px"
              searchPlaceholder={`Search LRStatus`}
              prevId={id.crossingTransactions}
              nextId={id.reportmainButton}
            />
          </Item>
          <Item
            sx={sx.itemsx}
            onKeyDown={(e) => {
              navigation3(
                e,
                showReport
                  ? isPdfLoading
                    ? 'backBtn'
                    : disableExcel
                    ? 'exportPdf'
                    : 'exportExcelBtn'
                  : isBranchWise
                  ? id.fromDate
                  : id.financialYear,
                id.status,
                () => {
                  generateNonMovementReport()
                }
              )
            }}
          >
            <SplitButton
              options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
              onClick1={generateNonMovementReport}
              onClick2={handleClick1}
              hideToggle={selLRStatus.id === 'BR'}
              id1={id.reportmainButton}
            />
          </Item>
          <Item sx={{ ...sx.itemsx }} onClick={reset}>
            <RefreshSvg />
          </Item>
        </Box>
      </Item>
      {/* {showReport && (
        <>
          {selReportView.id === 1 ? (
            <LRWiseDetailedStatus
              DefaultCurrencyID={DefaultCurrencyID}
              UseToPayAsCOD={UseToPayAsCOD}
              UseFormattedLRinReports={UseFormattedLRinReports}
              manageColumn={manageColumn}
              updateModal={updateModal}
              tableData={tableData}
              tableData2={tableData2}
              loginData={loginData}
              updateLoader={updateLoader}
              filterData={filterData}
              disableExcel={disableExcel}
              isPdfLoading={isPdfLoading}
              setIsPdfLoading={setIsPdfLoading}
              isBranchWise={isBranchWise}
              columnSummaryDefs={manageColumn.filter((obj) => obj.isSelected)}
            />
          ) : filterData.reportOptionId === 1 ? (
            <PaymentTypeWise
              DefaultCurrencyID={DefaultCurrencyID}
              loginData={loginData}
              tableData={tableData}
              tableData2={tableData2}
              updateLoader={updateLoader}
              filterData={filterData}
              disableExcel={disableExcel}
              isPdfLoading={isPdfLoading}
              setIsPdfLoading={setIsPdfLoading}
              isBranchWise={isBranchWise}
            />
          ) : filterData.reportOptionId == 2 ? (
            <BranchWiseSummary
              loginData={loginData}
              tableData={tableData}
              tableData2={tableData2}
              updateLoader={updateLoader}
              filterData={filterData}
              disableExcel={disableExcel}
              isPdfLoading={isPdfLoading}
              setIsPdfLoading={setIsPdfLoading}
              isBranchWise={isBranchWise}
            />
          ) : (
            <StatusWiseSummary
              loginData={loginData}
              tableData={tableData}
              tableData2={tableData2}
              updateLoader={updateLoader}
              filterData={filterData}
              disableExcel={disableExcel}
              isPdfLoading={isPdfLoading}
              setIsPdfLoading={setIsPdfLoading}
              isBranchWise={isBranchWise}
            />
          )}
        </>
      )} */}
      {showReport ? (
        <ReportTable
          tableData={tableData}
          tableData2={tableData2}
          filterData={filterData}
          viewId={selReportView.id}
          optionId={selReportOpt.id}
          columnDefs={resolveHeaders(selReportView.id, selReportOpt.id)}
        />
      ) : (
        <></>
      )}
      {mdt.LRWiseDetailsReport === modal ? <ManageColumns headers={manageColumn} onSave={onSaveColumns} updateModal={setModal} /> : null}
      {showAlert.show && <Alert msg={showAlert.message} error={true} close={handleCloseAlert} />}
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { getOwnChildBranches, getNonMovementFilterData, getBranchConfig, updateLoader, updateModal }

export default connect(mapStateToProps, mapDispatchToProps)(NonMovementReport)
